/**
 * Browser input policy for xterm's otherwise invisible textarea.
 *
 * A terminal must still accept normal mobile IME composition and clipboard
 * paste, so this deliberately does not use `inputmode="none"` or pretend a
 * password field. Those approaches either hide the native keyboard or change
 * it into an inappropriate keyboard layout. These attributes only opt out of
 * browser completion, correction, capitalization, and spell checking where a
 * browser honours them; a device keyboard may still expose its own suggestion
 * UI according to the user's keyboard settings.
 */
export const TERMINAL_TEXT_INPUT_ATTRIBUTES = {
  autocomplete: 'off',
  autocorrect: 'off',
  autocapitalize: 'off',
  spellcheck: 'false'
} as const;

type TerminalTextInput = Pick<HTMLTextAreaElement, 'setAttribute'>;

/** Applies the policy after xterm has created its public `textarea`. */
export function configureTerminalTextInput(textarea: TerminalTextInput | undefined) {
  if (!textarea) return;
  for (const [name, value] of Object.entries(TERMINAL_TEXT_INPUT_ATTRIBUTES)) {
    textarea.setAttribute(name, value);
  }
}
